import styleInject from '../../../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".ItemContent-module_itemContent__Xcfrh {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.ItemContent-module_rightIcon__QVnw4 {\n  position: absolute;\n  top: calc(50% - 8px);\n  right: 0px;\n}\n.ItemContent-module_rightIcon__QVnw4 svg {\n  width: 24px;\n  height: 24px;\n}";
var styles = {"itemContent":"ItemContent-module_itemContent__Xcfrh","rightIcon":"ItemContent-module_rightIcon__QVnw4"};
styleInject(css_248z);

export { styles as default };
